import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyA4mQyEVP1krDqlc9URzAwCxz9PfzzARhw",
    authDomain: "lirazyosef-93933.firebaseapp.com",
    projectId: "lirazyosef-93933",
    storageBucket: "lirazyosef-93933.firebasestorage.app",
    messagingSenderId: "659497451181",
    appId: "1:659497451181:web:0d93838e445e328e739024"
  };

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app); 
